import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
	children: React.ReactNode;
}

export const DropdownPortal = ({ children }: Props) => {
	const [mounted, setMounted] = useState(false);

	useEffect(() => setMounted(true), []);

	if (!mounted) return null;

	return createPortal(children, document.body);
};
